module.exports = __webpack_public_path__ + "static/img/logo.7898003.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 20